var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length)?_c('div',{staticClass:"finance-bank"},[_c('div',{staticClass:"section-label"},[_vm._v("金融机构")]),_c('OptionBox',{attrs:{"options":_vm.list,"value":_vm.value,"value-key":"bank_id","label-key":"bank_name"},on:{"change":_vm.selectBank}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }